import { render } from "./RepurchaseCard.vue?vue&type=template&id=5d6203bb&scoped=true"
import script from "./RepurchaseCard.vue?vue&type=script&lang=js"
export * from "./RepurchaseCard.vue?vue&type=script&lang=js"

import "./RepurchaseCard.vue?vue&type=style&index=0&id=5d6203bb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6203bb"]])

export default __exports__